import React, { useEffect, useState, useRef } from "react";
import { Document, Page } from "react-pdf";
import "../../styles/user/PdfPreviewModal.css";

const PdfPreviewModal = ({ fileUrl, fileType, onClose }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfWidth, setPdfWidth] = useState(600);
  const modalRef = useRef(null);

  const isPdf = fileType === "pdf";

  useEffect(() => {
    setPageNumber(1);
    setNumPages(null);
  }, [fileUrl]);

  useEffect(() => {
    const updateWidth = () => {
      if (modalRef.current) {
        setPdfWidth(modalRef.current.clientWidth - 40);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (!fileUrl) return null;

  return (
    <div className="pdf-modal-overlay" onClick={onClose}>
      <div
        className="pdf-modal"
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="pdf-close" onClick={onClose}>
          ✕
        </button>

        {isPdf ? (
          <>
            <div className="pdf-container">
              <Document
                file={fileUrl}
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                loading="Loading PDF..."
                error="Failed to load PDF"
              >
                <Page
                  pageNumber={pageNumber}
                  width={pdfWidth}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              </Document>
            </div>

            {numPages > 1 && (
              <div className="pdf-controls">
                <button
                  disabled={pageNumber === 1}
                  onClick={() => setPageNumber((p) => p - 1)}
                >
                  ‹
                </button>

                <span>
                  {pageNumber} / {numPages}
                </span>

                <button
                  disabled={pageNumber === numPages}
                  onClick={() => setPageNumber((p) => p + 1)}
                >
                  ›
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="image-container">
            <img src={fileUrl} alt="Preview" className="image-preview" />
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfPreviewModal;